import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IUpdateRoleActionRequest {
  id: number;
  roleId: [number]; 
  microServiceName: string;
  controllerName: string;
  actionName: string;
  canCall: boolean;
}

async function updateRoleAction(data: IUpdateRoleActionRequest): Promise<any> {
  try {
    return (await axiosInstance.put("/RoleAction/Update", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateRoleAction() {
  return useMutation<any, Error, IUpdateRoleActionRequest>((variables) =>
    updateRoleAction(variables)
  );
}
